import '.e{display:grid;}.ssr-plugin'
import '.gc{grid-template-columns:repeat(3, 6.875rem);}.ssr-plugin'
import '.p{gap:1.5rem;}.ssr-plugin'
import { Initiative } from '@schema/initiative'
import { PhaseType } from '@schema/phase'
import {
  InitiativeCreationStep,
  initiativeCreationSteps,
} from '../blocks/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import { useCallback, useEffect, useState } from 'react'
import { useInitiativeAutoSave } from '../blocks/useInitiativeAutoSave'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'
import { useQuery } from '@based/sdk/react'
import { AmenityListModel } from 'functions/app/amenity/list'
import { AmenityCard } from '../blocks/AmenityCard'
import { AddCustomAmenityCard } from '../blocks/AddCustomAmenityCard'

const MAX_CUSTOM_AMENITIES = 6

export const AmenitiesStep = ({
  initiative,
  selectedPhaseType,
  completeStep,
  uncompleteStep,
}: {
  initiative: Partial<Initiative>
  selectedPhaseType: PhaseType
  completeStep: (step: InitiativeCreationStep) => void
  uncompleteStep: (step: InitiativeCreationStep) => void
}) => {
  const selectedAmenityIds = (initiative.amenities ?? []).map((a) => a.id)
  const [selectedIds, setSelectedIds] = useState<number[]>(selectedAmenityIds)

  const amenitiesQuery = useQuery('list-amenities', {
    initiativeId: initiative.id,
  })
  const amenities: AmenityListModel[] = amenitiesQuery.data ?? []

  useInitiativeAutoSave(initiative.id, {
    amenities: selectedIds.map((id) => ({ id })),
  })

  const toggleAmenity = useCallback((id: number) => {
    setSelectedIds((prev) => {
      const i = prev.indexOf(id)
      return i > -1 ? prev.toSpliced(i, 1) : [...prev, id]
    })
  }, [])

  const addSelectedId = useCallback((id: number) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev : [...prev, id]))
  }, [])

  useEffect(() => {
    if (selectedIds.length > 0) {
      completeStep(initiativeCreationSteps.amenities)
    } else {
      uncompleteStep(initiativeCreationSteps.amenities)
    }
  }, [selectedIds.length, completeStep, uncompleteStep])

  const canAddCustom =
    amenities.filter((a) => a.custom).length < MAX_CUSTOM_AMENITIES

  return (
    <CreationGuide
      selectedPhaseType={selectedPhaseType}
      currentStep={initiativeCreationSteps.amenities}
    >
      <Column gap="1.5rem">
        <div className="e gc p"
        >
          {amenities.map((a) => (
            <AmenityCard
              key={a.id}
              label={a.name}
              iconName={a.iconName}
              selected={selectedIds.includes(a.id)}
              onClick={() => toggleAmenity(a.id)}
            />
          ))}
          {canAddCustom && (
            <AddCustomAmenityCard
              initiativeId={initiative.id}
              onSelectId={addSelectedId}
            />
          )}
        </div>
      </Column>
    </CreationGuide>
  )
}
